import { NotificationManager } from 'Components/Notifications';
import { detectBrowser } from 'Core/data/Helpers'

// Only web URLs may be opened from a notification: a "javascript:" or "data:" URL would run in this page.
const isHttpUrl = (value) => {
  try {
    return ['http:', 'https:'].includes(new URL(value).protocol);
  } catch {
    return false;
  }
};

export class OPEN_URL {

  execute = (payload, state, dispatch) => {

    // check the target to see if it is shown to all users.
    // open the url
    // show the notification
    // display the message with the "message
    // the url arrives in the data field { link: "" }
    if (payload.data?.status === 'SUCCESS') {
      if (!payload.sessionId || payload.sessionId == sessionStorage.getItem("sessionId")) {
        if (payload.data?.url.length) {
          NotificationManager.success(
            null,
            null,
            3000,
            null,
            null,
            null,
            payload.message,
            payload.messageTitle
          );
          // Valid if export type for refreshing reports
          if(payload.message === "reportsMainRT_exportReportMessageSuccess"){
            const {data} = payload || {};
            if(data?.url?.length > 1){
              return [true, { newReport:{exportFile: true}, openUrlNotification: data }]
            }
              return [true, { newReport:{exportFile: true}, openUrlNotification: payload.data }]
          }

          return this.openLink(payload.data?.url, dispatch);
        }

        NotificationManager.success(
          null,
          null,
          3000,
          null,
          null,
          null,
          'reportsMainRT_noDataMessage',
          payload.messageTitle
        );

        if(payload.message === "reportsMainRT_exportReportMessageSuccess"){
          return [true, { newReport:{exportFile: true} }]
        }

      }
    } else {
      NotificationManager.error(
        null,
        null,
        0,
        null,
        null,
        null,
        payload.message,
        payload.messageTitle
      );
    }
    return [false, {}]
  }

  openLink(link, dispatch) {
    if (link) {
      if (Array.isArray(link) && link.length > 1) {
          return [true, { newReport:{exportFile: true}, openUrlNotification: data }]
      }
      const newLink = Array.isArray(link) ? link[0]?.url : link
      // If the url is not empty, open the link
      if (newLink) {
        const url = newLink?.includes("http") ? newLink : `https://${newLink}`;
        if (!isHttpUrl(url)) return [false, {}];
        if (detectBrowser() === 'Firefox') {
          window.open(url, '_blank', 'noopener,noreferrer')
        } else {
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.click();
          document.body.removeChild(a);
        }
        return [false, {}]
      }
    }
  }
}
